/**
 * @file Encargado de proporcionar la funcionalidad para, teniendo en cuenta el json de
 * configuración del flujo, decidir a que step visual se llega.
 * @module Stepper.StepperDecisor
 */
/**
 * Método que busca el objeto del paso que se le pasa por parámetro
 * @param {strip} actualStep id del paso actual
 * @returns Objeto del paso buscado
 */
const searchActualStep = (actualStep, flow) => {
  if (!actualStep) {
    return null;
  }

  return flow.steps.find(step => step.searchId === actualStep.searchId);
};

/**
 * Métoto que ejecuta una condición
 * @param {array} conditions Conjunto de condiciones desarrolladas en el proyecto invocante
 * @param {*} conditionToExecute Condición que se debe ejecutar
 * @param {*} state Redux state
 * @returns Devuelve true si se satisface la condición o false en caso contrario
 */
const executeCondition = (conditions, conditionToExecute, state) => {
  let conditionState = false;
  if (conditions[conditionToExecute]) {
    conditionState = conditions[conditionToExecute](state);
  }

  return conditionState;
}

/**
 * Método que decide cual va a ser el siguiente paso
 * @param {obj} state Redux state
 * @param {array} conditions Conjunto de condiciones desarrolladas en el proyecto invocante
 * @returns Nuevo paso al que redirigir el flujo
 */
export const decideStepToLoad = (state, conditions, flow) => {
  if (!flow) {
    return {
      newStep: null,
      actualStepIndex: 0,
    };
  }
  const actualStepObj = searchActualStep(state.actualStep, flow);
  let index = -1;

  if (actualStepObj) {
    index = flow.steps.indexOf(actualStepObj);
  }

  let newStep = actualStepObj;

  for (let i = (index + 1); i < flow.steps.length; i += 1) {
    const step = flow.steps[i];

    let canReachStep = true;

    for (let j = 0; j < step.conditions.length; j += 1) {
      const condition = step.conditions[j];
      if (!executeCondition(conditions, condition, state)) {
        canReachStep = false;
        break;
      }
    }

    if (canReachStep) {
      newStep = step;
      break;
    }
  }

  if (newStep
    && !newStep.isSummaryStep
    && !newStep.isGhostStep
    && !newStep.isErrorStep
    && state
    && state.confirmedSteps
    && state.confirmedSteps.length === 1 // El inicial siempre va a estar confirmado
    && flow.nonOneClickFlowInitialStep
  ) {
    newStep = flow.nonOneClickFlowInitialStep;
  }

  let { actualStepIndex } = state;
  if (newStep) {
    actualStepIndex = flow.steps.indexOf(newStep) + 1;
  }

  return {
    newStep: newStep || state.actualStep,
    actualStepIndex,
  };
}
